export default __webpack_public_path__ + "static/10-00ac9e1092956f8748c15944da64ac10.jpg";